
import * as React from 'react';
import  { AppBar, Box, Button, Container, Toolbar } from '@mui/material';
import blueLogo from 'assets/images/companyLogo.svg'

const pages = ['Ride','Driver','More'];

function FAQHeader() {
  
  return (
    <AppBar position="static" className="bgColorBlue boxShadowNone">
      <Container maxWidth="xl" className='height100 faqMobileRes '>
        <Toolbar disableGutters>
          <img src={blueLogo} alt='blueLogo' className='logoImage'/>  
          <Box sx={{ display: { md: 'flex' } }}>
            {pages.map((page) => (
              <Button
               className='font18 marginLeft20 fontNormal textCaptialize'
                key={page}
              >
                {page}
              </Button>
            ))}
          </Box>
          <Box sx={{ display: { md: 'flex' ,justifyContent:'end' } }}>
              <Button
              className='font18 fontNormal textCaptialize'
              >
                Help
              </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default FAQHeader;